module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.6679d67d.ttf";